import http from 'hub-http/clients/noPortalApiClient';
import { createRpcClientV2 } from 'rpc-client-utils';
import { validateHubsRpc } from '../../__generated__/chirp/com/hubspot/partner/demo/rpc/PartnerDemoHubValidationRpc';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});
export async function validateDemoHubs(accounts) {
  var _response$results;
  const hubIdsByHublet = {};
  for (const account of accounts) {
    const {
      hublet
    } = account;
    if (hublet) {
      if (!hubIdsByHublet[hublet]) {
        hubIdsByHublet[hublet] = [];
      }
      hubIdsByHublet[hublet].push(account.id);
    }
  }
  const response = await rpcClient.call(validateHubsRpc, {
    request: {
      hubIdsByHublet
    }
  });
  return (_response$results = response.results) !== null && _response$results !== void 0 ? _response$results : {};
}